'use client'

import clsx from 'clsx'
import React, { memo, MouseEvent, useState } from 'react'
import { useDispatch } from 'react-redux'

import { addToFavorites, removeFromFavorites } from 'store/slices/favorites'

import { NotificationMessage } from '@/features/product/NotificationMessage/NotificationMessage'

import { CardData } from '@/entities/card'

import { Toast } from '@/shared/ui/Toast'

import { useIsInFavorites } from '../hooks/isInFavorites'

import cl from './AddToFavorires.module.scss'

const title = 'Добавить в избранное'

interface AddToFavoriresProps {
	className?: string
	productCode: string
	data: CardData
}

export const AddToFavorires = memo((props: AddToFavoriresProps) => {
	const { className, productCode, data } = props

	const dispatch = useDispatch()
	const isInFavorites = useIsInFavorites(productCode)
	const [isToastOpen, setIsToastOpen] = useState(false)

	const toggle = (e: MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation()
		e.preventDefault()

		if (isInFavorites) {
			dispatch(removeFromFavorites(productCode))
		} else {
			dispatch(addToFavorites(productCode))
			setIsToastOpen(true)
		}
	}

	const classes = clsx(cl.root, className, {
		[cl.inFavorites]: isInFavorites
	})

	return (
		<>
			<button className={classes} onClick={toggle} title={title}>
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
					<path
						d="M15.2889 5C18.1067 5 20 7.6075 20 10.04C20 14.9663 12.1422 19 12 19C11.8578 19 4 14.9663 4 10.04C4 7.6075 5.89333 5 8.71111 5C10.3289 5 11.3867 5.79625 12 6.49625C12.6133 5.79625 13.6711 5 15.2889 5Z"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			</button>

			<Toast isOpen={isToastOpen} onClose={() => setIsToastOpen(false)} position="bottom-center" duration={50000}>
				<NotificationMessage
					buttonText="В избранное"
					imageSrc={data.images[0]}
					link="/favorites"
					text={data.title}
					mobileButtonText="Перейти"
					mobileText="Товар добавлен в избранное"
				/>
			</Toast>
		</>
	)
})
